import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import localCurrency from "cldr-numbers-full/main/no/currencies.json";
import numbers from "cldr-numbers-full/main/no/numbers.json";
import caGregorian from "cldr-dates-full/main/no/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/no/dateFields.json";

import { IntlProvider, load } from "@progress/kendo-react-intl";
import CustomRouter from "./router";
import i18n from "i18n";

weekData.supplemental.weekData.firstDay.US = "mon"; // Set Monday as the first day of the week for Norwegian locale

//note: loading number  data will cause breaking
// Patch CLDR numbers object to ensure any '*Formats-numberSystem-latn' entries have a 'standard' string.
// Some CLDR files (rationalFormats-numberSystem-latn, etc.) use different keys and lack `standard`;
// Kendo's loader expects a `.standard` string and will call .replace on it. We add safe fallbacks here
// const patchedNumbers = JSON.parse(JSON.stringify(numbers));

if (
	(numbers.main.no.numbers["rationalFormats-numberSystem-latn"] as any)
		.standard === undefined
) {
	(
		numbers.main.no.numbers["rationalFormats-numberSystem-latn"] as any
	).standard = "#,##0.###";
}

// const numbersLocaleKey = Object.keys(patchedNumbers.main || {})[0];
// if (numbersLocaleKey) {
// 	const nums = patchedNumbers.main[numbersLocaleKey].numbers;
// 	const decimalStd =
// 		nums &&
// 		nums["decimalFormats-numberSystem-latn"] &&
// 		nums["decimalFormats-numberSystem-latn"].standard;
// 	const fallbackStandard = decimalStd || "#,##0.###";

// 	Object.keys(nums || {}).forEach((fieldName) => {
// 		if (fieldName.includes("Formats-numberSystem-latn")) {
// 			const field = nums[fieldName];
// 			if (!field || typeof field.standard !== "string") {
// 				if (!field) {
// 					nums[fieldName] = { standard: fallbackStandard };
// 				} else {
// 					field.standard = fallbackStandard;
// 				}
// 			}
// 		}
// 	});
// }

load(
	likelySubtags,
	currencyData,
	weekData,
	localCurrency,
	// patchedNumbers,
	numbers,
	caGregorian,
	dateFields
);

function App() {
	return (
		//<IntlProvider locale="no-NO">
		<IntlProvider locale={i18n.language === "en" ? "en-US" : "no-NO" }>		
			<BrowserRouter>
				<CustomRouter />
			</BrowserRouter>
		</IntlProvider>
	);
}

export default App;
